import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { CardComponent } from '../../ui/card/card.component';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { VarijabilneValuteService } from 'src/app/shared/services/varijabilne-valute.service';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CurrencyModel } from 'src/app/shared/models/paymentInfo.model';
import { PaymentInfoService } from 'src/app/shared/services/payment-info.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { NumberInputStandaloneComponent } from '../../number-input-standalone/number-input-standalone.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-varijabilne-valute-modal',
  imports: [CommonModule, CardComponent, FormsModule, ReactiveFormsModule, TranslateModule, NgSelectModule,
     NumberInputStandaloneComponent, NgbTooltipModule],
  templateUrl: './varijabilne-valute-modal.component.html',
  styleUrl: './varijabilne-valute-modal.component.scss'
})
export class VarijabilneValuteModalComponent implements OnInit {
  @Input() setValuta: boolean = false;
  @Input() updateInputValue = new EventEmitter();
  valute;
  valutaId = null;
  public activeTab: number = 1;
  currencies: CurrencyModel[] = [];

  form = new UntypedFormGroup({
    sifra: new UntypedFormControl(0),
    valuta: new UntypedFormControl(null, Validators.required),
    kurs: new UntypedFormControl(1, Validators.required),
    datum: new UntypedFormControl(formatDate(new Date(Date.now()), 'yyyy-MM-dd', 'en'), Validators.required),
  });

  handleStep(value: number) {
    if (value == -1) {
      this.activeTab = this.activeTab - 1;
    } else if (value == 1 && this.activeTab < 3) {
      this.activeTab = this.activeTab + 1;
    }

    if (this.activeTab == 1) {
      this.getVarijabilneValute();
    }
  }

  constructor(
    private varijabilneValuteService: VarijabilneValuteService,
    private paymentInfoService: PaymentInfoService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private modalService: BsModalService,
    private datePipe: DatePipe,
    public bsModalRef: BsModalRef,
  ) { }

  ngOnInit(): void {
    this.getVarijabilneValute();
    this.loadCurrencies();
  }

  getVarijabilneValute() {
    this.varijabilneValuteService.getAll().subscribe(resp => {
      this.valute = resp;
    })
  }

  private loadCurrencies() {
    this.paymentInfoService.getAllCurrencies().subscribe((currencies) => {
      this.currencies = currencies;
    });
  }

  onSubmit() {
    if (this.form.valid) {
      if (this.valutaId) { this.updateValuta(); }
      else { this.createValuta(); }
    }
    else { this.form.markAllAsTouched(); }
  }

  updateValuta() {
    this.varijabilneValuteService.update(this.form.value).subscribe(resp => {
      this.valutaId = null;
      this.handleStep(-1);
      this.toastr.success(this.translate.instant("MESSAGE.Valuta uspješno izmijenjena"))
    })
  }

  createValuta() {
    this.varijabilneValuteService.create(this.form.value).subscribe(resp => {
      this.valutaId = null;
      this.handleStep(-1);
      this.toastr.success(this.translate.instant("MESSAGE.Valuta uspješno kreirana"))
    })
  }

  valutaChange() {
    var tmpValuta = this.form.controls.valuta.value;
    var valuta = this.currencies.find(x => x.sifra == tmpValuta);
    if (valuta) {
      this.form.controls.kurs.setValue(valuta.kurs);
    }
  }

  edit(item) {
    this.valutaId = item.sifra;
    this.form.controls.sifra.setValue(item.sifra);
    this.form.controls.valuta.setValue(item.valuta);
    this.form.controls.kurs.setValue(item.kurs);
    this.form.controls.datum.setValue(item.datum);

    let pipedDatum = this.datePipe.transform(item.datum, 'yyyy-MM-dd');
    this.form.controls.datum.setValue(pipedDatum);

    this.handleStep(1)
  }

  openDeleteConfirmModal(sifra) {
    const initialState: ModalOptions = {
      initialState: {
        text: this.translate.instant("MESSAGE.Da li ste sigurni da zelite da izbrisete kurs") + '?'
      },
      class: 'modal-dialog-centered'
    };
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    this.bsModalRef.content.updateInputValue.subscribe((res: any) => {
      if (res) {
        let payload = {
          sifra: sifra,
        };
        this.varijabilneValuteService.delete(payload).subscribe((res) => {
          this.toastr.success(this.translate.instant("MESSAGE.Kurs uspješno obrisan"));
          this.getVarijabilneValute();
        });
      }
    });
  }

  forceCloseModal() {
    this.bsModalRef.hide();
  }

  useValuta(item) {
    this.updateInputValue.emit(item.kurs);
    this.forceCloseModal();
  }

}
